import(/* webpackMode: "eager" */ "D:\\a\\1\\s\\WDS.NGP\\WDS.NGP.Web\\ClientApp\\src\\app\\page.tsx");
